export default "__VITE_ASSET__BMdPl7vQ__"